import errorReporter from '@app/errorReporter';
import { message } from 'antd';

export const ShowingDetailsErrorWrapper = async <T, V>(
  fn: (args: T) => Promise<V>,
  args: T,
  msg: string,
) => {
  try {
    return await fn(args);
  } catch (err) {
    errorReporter.error(`${msg}: ${err}`);
    message.error(msg);
  }
};
